import { css } from 'styled-components';
import breakPoint from './break-point';

export default function(size, content) {
  return css`
    @media only screen and ${breakPoint(size)} {
      ${content}
    }
  `;
}